import { createContext, type ReactNode, useContext } from "react";

interface ApiClientContextProps {
  apiClient: ApiClient;
}

const ApiClientContext = createContext<ApiClientContextProps | null>(null);

export interface ApiClient {
  get<T>(
    url: string,
    refreshCache?: boolean,
    options?: RequestInit,
  ): Promise<Readonly<T>>;
  post<T>(
    url: string,
    data?: object,
    options?: RequestInit,
  ): Promise<Readonly<T>>;
  put<T>(
    url: string,
    data?: object,
    options?: RequestInit,
  ): Promise<Readonly<T>>;
  delete<T>(url: string, options?: RequestInit): Promise<Readonly<T>>;
}

export const ApiClientProvider = ({
  children,
  apiClient,
}: {
  children: ReactNode;
  apiClient: ApiClient;
}) => {
  return (
    <ApiClientContext.Provider value={{ apiClient }}>
      {children}
    </ApiClientContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useApiClient = () => {
  const context = useContext(ApiClientContext);
  if (context === null) {
    throw new Error("useApiClient must be used within a ApiClientProvider");
  }
  return context.apiClient;
};
